export const isDevelopment = () => process.env.NODE_ENV === 'development';
export const isProduction = () => /channelpartner\.blackbear\.energy/.test(window.location.href);
export const isStaging = () =>
  /channelpartner\.staging\.blackbear\.energy/.test(window.location.href);
